import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  Spin,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { save } from "../../../features/save/saveSlice";
import InsideHeader from "../../../components/InsideHeader";
import { normalizeDateToLocalYear } from "../../../utils";
import { fetchBank } from "../../../features/dropdown/dropdownSlice";

const { TextArea } = Input;
function CasualAdd({ setactive }) {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { user } = useSelector((state) => state.auth);
  const {
    countryData,
    genderData,
    staffStatus,
    staffGradeData,
    staffPositionByGrade,
    staffTerm,
    staffCategory,
    payrollType,
    coBranch,
    depts,
    bank,
    loading,
  } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);

  const { fldLoading, singlePersonnel, casualObj } = useSelector(
    (state) => state.folder
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState();

  const today = new Date();
  let dd = String(today.getDate()).padStart(2, 0);
  let mm = String(today.getMonth() + 1).padStart(2, 0);
  let yyyy = today.getFullYear() - 18;

  let minDate = `${yyyy}-${mm}-${dd}`;

  const [data, setdata] = useState({});

  useEffect(() => {
    setFormData();
  }, []);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  function onMonthChange(value) {
    setFormData((prevData) => ({
      ...prevData,
      csStartDate: value,
    }));
  }

  const handleCancel = async (e) => {
    navigate(-1);
  };

  const onFinish = async (data) => {
    data.csId = casualObj?.csId ? casualObj?.csId : null;
    data.csStartDate = normalizeDateToLocalYear(data.csStartDate);
    data.csExpiryDate = normalizeDateToLocalYear(data.csExpiryDate);
    data.csStatus = "ACTIVE";
    data.csSiteId = null;
    const res = await dispatch(
      save({
        url: "hr/saveCasual.action",
        ...data,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await navigate("/casual-profile");
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const initialFormValues = {
    ...casualObj,
    csStartDate: casualObj?.csStartDate
      ? dayjs(casualObj?.csStartDate)
      : data?.csStartDate
      ? dayjs(data?.csStartDate)
      : null,
    csExpiryDate: casualObj?.csExpiryDate
      ? dayjs(casualObj?.csExpiryDate)
      : data?.csExpiryDate
      ? dayjs(data?.csExpiryDate)
      : null,
  };

  const [loadingAttach, setLoadingAttach] = useState(false);
  const [profile, setProfile] = useState(
    formData?.usrIcon ? formData?.usrIcon : ""
  );
  const handleImageSelect = async (event) => {
    // setLoadingAttach(true);
    // const formData = new FormData();
    // formData.append("file", event.target.files[0]);
    // const res = await dispatch(saveFile(formData));
    // if (res?.payload?.success) {
    //   setLoadingAttach(false);
    //   setProfile(res?.payload?.jsonData ?? "");
    // } else {
    //   setLoadingAttach(false);
    //   toast.error("Please try upload your image again");
    // }
  };
  async function fetchBankData() {
    dispatch(fetchBank());
  }
  useEffect(() => {
    fetchBankData();
  }, []);

  return (
    <>
      <div className="w-full h-full overflow-y-scroll">
        <InsideHeader
          title="Casual Profile"
          subtitle="Manage Casual Profile within your institution"
          back={true}
          title1="Casual"
          title2="casual Add"
        />
        <div className="flex  ">
          <div className="w-full  ">
            <div className="flex flex-col w-full ">
              <Form
                layout="vertical"
                ref={formRef}
                name="control-ref"
                onFinish={onFinish}
                style={{
                  maxWidth: "100%",
                }}
                initialValues={initialFormValues}
                // onValuesChange={handleValuesChange}
                form={form}
              >
                <div className="mt-[2rem] p-3 !pr-0 lg:!pr-10 lg:p-0 py-[.5rem] flex flex-col justify-center w-full rounded-[.5625rem]">
                  <div className="my-[.25rem] px-[1.37rem] flex flex-col items-start justify-start ">
                    <div className="flex items-center gap-x-5">
                      <div className="bg-[#EDF8FF] w-[3.5rem] h-[3.5rem] rounded-full flex justify-center items-center">
                        <span className="paragraph_paragraph_bb08">1</span>
                      </div>
                      <span className="paragraph_paragraph_bb13">
                        Personal Details
                      </span>
                    </div>

                    <div className="w-full flex flex-col ml-[5rem]">
                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-5 w-full">
                        <Form.Item
                          className="table-form-item"
                          name="csName"
                          label="Casual Name"
                          rules={[
                            {
                              required: true,
                              message: "Please add Casual Name",
                            },
                          ]}
                        >
                          <Input className="input" />
                        </Form.Item>

                        <Form.Item
                          className="table-form-item"
                          name="csNationalId"
                          label="National ID"
                          rules={[
                            {
                              required: true,
                              message: "Please add national ID",
                            },
                            {
                              validator(_, value) {
                                if (value && value.toString().length < 6) {
                                  return Promise.reject(
                                    "National ID must be at least 6 characters long"
                                  );
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <InputNumber
                            min={0}
                            formatter={(value) => value}
                            parser={(value) =>
                              value?.replace(/\$\s?|(,*)/g, "")
                            }
                            className="input flex"
                          />
                        </Form.Item>

                        <Form.Item
                          className="table-form-item"
                          name="csDuration"
                          label="Duration"
                          rules={[
                            {
                              required: true,
                              message: "Please add duration",
                            },
                          ]}
                        >
                          <InputNumber
                            min={0}
                            formatter={(value) =>
                              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }
                            parser={(value) =>
                              value?.replace(/\$\s?|(,*)/g, "")
                            }
                            className="input flex"
                          />
                        </Form.Item>

                        <Form.Item
                          className="table-form-item"
                          name="csRate"
                          label="Rate"
                          rules={[
                            {
                              required: true,
                              message: "Please add rate",
                            },
                          ]}
                        >
                          <InputNumber
                            min={0}
                            formatter={(value) =>
                              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }
                            parser={(value) =>
                              value?.replace(/\$\s?|(,*)/g, "")
                            }
                            className="input flex"
                          />
                        </Form.Item>

                        <Form.Item
                          rules={[
                            {
                              required: false,
                              message: "Field is required",
                            },
                          ]}
                          name="csStartDate"
                          label="Start Date"
                        >
                          <DatePicker className="input" />
                        </Form.Item>

                        <Form.Item
                          rules={[
                            {
                              required: false,
                              message: "Field is required",
                            },
                          ]}
                          name="csExpiryDate"
                          label="Expiry Date"
                        >
                          <DatePicker className="input" />
                        </Form.Item>

                        <Form.Item
                          name="csBankName"
                          className=""
                          label={<span>Bank</span>}
                          rules={[
                            {
                              required: true,
                              message: "Please select Bank",
                            },
                          ]}
                        >
                          <Select
                            className=""
                            allowClear
                            style={{
                              width: "100%",
                            }}
                            options={
                              bank?.length > 0 &&
                              bank?.map((item) => ({
                                value: item?.jbnkBankName,
                                label: item?.jbnkBankName,
                              }))
                            }
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (
                                option?.label?.toLocaleLowerCase() ?? ""
                              ).includes(input?.toLocaleLowerCase())
                            }
                            dropdownRender={(menu) => (
                              <>
                                {loading && (
                                  <div
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Spin className="sms-spin" />
                                  </div>
                                )}
                                {menu}
                              </>
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name="csBankAccount"
                          label="Bank Account Number"
                          rules={[
                            {
                              required: true,
                              message: "Enter Bank Account",
                            },
                          ]}
                        >
                          <Input className="input" />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex justify-center flex-col text-center mt-1 mb-20 gap-y-2 items-center">
                  <div className="w-[200px]">
                    <button
                      key="submit"
                      type="submit"
                      className="cstm-btn"
                      disabled={saving}
                    >
                      {saving ? <Spin /> : "Save"}
                    </button>
                  </div>
                  <div className="w-[200px]">
                    <button
                      onClick={() => navigate(-1)}
                      key="back"
                      type="button"
                      className="cstm-btn !bg-white !text-black1 !border !border-black1"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CasualAdd;
